import { Omfragad } from '../../model/LedningDto';
import { Firmateckning } from './Firmateckning';
import { LedningTable } from './LedningTable';

interface LedningProps {
  ledning: Omfragad;
}

export const Ledning: React.FC<LedningProps> = ({ ledning }) => {
  if (!ledning) {
    return <></>;
  }
  const ledningMembers = ledning.ledningslista?.ledamot;
  const companySignature = ledning.firmateckningslista?.firmateckning;

  return (
    <div>
      <Firmateckning signatures={companySignature} />
      <h3>Ledningsledamöter</h3>
      <LedningTable ledningMembers={ledningMembers} />
    </div>
  );
};
